var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24 10c4.607 0 8.359 3.48 8.496 7.821l.004.247v2.847H36a2 2 0 012 2V36a2 2 0 01-2 2H12a2 2 0 01-2-2V22.915a2 2 0 012-2h3.5v-2.847c0-4.373 3.666-7.934 8.24-8.064L24 10zm0 15a3 3 0 00-1 5.83V34h2v-3.171A3.001 3.001 0 0024 25zm0-12.153c-2.962 0-5.377 2.222-5.495 5.006l-.005.215v2.847h11v-2.847c0-2.74-2.225-4.988-5.054-5.204l-.225-.012-.221-.005z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
